import script from "./AppModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppModal.vue?vue&type=script&lang=ts&setup=true"

import "./AppModal.vue?vue&type=style&index=0&id=380982fc&lang=css"

const __exports__ = script;

export default __exports__